// courses/course_S01.ts

export const course_S01 = `
  <div style="margin-bottom: 25px;">
    <h4 style="color: #0369a1; border-bottom: 2px solid #e2e8f0; padding-bottom: 8px; margin-bottom: 12px;">1. 음악 방송 현장: "분 단위 스케줄과의 싸움"</h4>
    <p style="margin-bottom: 10px; line-height: 1.6;">음악 방송(음방)은 이른 새벽 사전 녹화부터 생방송까지 하루 종일 진행되는 강행군입니다.</p>
    <ul style="padding-left: 20px; line-height: 1.6;">
      <li style="margin-bottom: 8px;"><strong>드라이 리허설 & 카메라 리허설:</strong> 아티스트가 무대 동선을 맞출 때, 매니저는 모니터링 위치에서 카메라 앵글과 아티스트의 위치를 확인합니다.</li>
      <li style="margin-bottom: 8px;"><strong>본 녹화 및 생방송 대기:</strong> 출연 순서를 엄수하고, 아티스트가 무대에 올라가기 직전 마이크 상태와 인이어(In-Ear) 장착 여부를 최종 점검합니다.</li>
      <li><strong>대기실 로테이션:</strong> 다른 가수들과 대기실을 공유하거나 좁은 공간에서 움직여야 하므로, 아티스트의 짐이 섞이지 않게 관리하고 이동 동선을 미리 확보합니다.</li>
    </ul>
  </div>

  <div style="margin-bottom: 25px;">
    <h4 style="color: #0369a1; border-bottom: 2px solid #e2e8f0; padding-bottom: 8px; margin-bottom: 12px;">2. 공연 및 행사 현장: "안전이 곧 실력입니다"</h4>
    <p style="margin-bottom: 10px; line-height: 1.6;">콘서트, 지역 축제, 대학 축제 등 관객과 직접 만나는 현장입니다.</p>
    <ul style="padding-left: 20px; line-height: 1.6;">
      <li style="margin-bottom: 8px;"><strong>무대 환경 체크:</strong> 무대 바닥이 미끄럽지는 않은지, 특수효과(폭죽, 불꽃) 위치가 아티스트에게 위험하지 않은지 현장 감독과 소통합니다.</li>
      <li style="margin-bottom: 8px;"><strong>큐시트(Cue Sheet) 숙지:</strong> 곡 순서, 멘트 타임, 의상 교체 타이밍을 완벽히 외워 아티스트가 당황하지 않게 리드합니다.</li>
      <li><strong>음원 및 소품 관리:</strong> 공연에 사용할 MR(반주) 상태를 음향팀과 최종 확인하고, 무대에서 사용하는 마이크나 소품을 철저히 챙깁니다.</li>
    </ul>
  </div>

  <div style="margin-bottom: 25px;">
    <h4 style="color: #0369a1; border-bottom: 2px solid #e2e8f0; padding-bottom: 8px; margin-bottom: 12px;">3. 현장 이동과 경호: "군 작전처럼 신속하게"</h4>
    <p style="margin-bottom: 10px; line-height: 1.6;">가수 현장은 팬들이 많이 모이기 때문에 이동 자체가 하나의 큰 업무입니다.</p>
    <ul style="padding-left: 20px; line-height: 1.6;">
      <li style="margin-bottom: 8px;"><strong>인파 관리:</strong> 차에서 내려 무대까지 가는 길에 팬들이 몰릴 경우, 아티스트가 다치지 않게 팔을 벌려 공간을 확보하고 신속하게 이동합니다.</li>
      <li><strong>차량 대기:</strong> 무대가 끝나자마자 바로 빠져나갈 수 있도록 차량을 출구와 가장 가까운 곳에 대기시키고 시동을 걸어둡니다.</li>
    </ul>
  </div>

  <div style="margin-bottom: 25px;">
    <h4 style="color: #0369a1; border-bottom: 2px solid #e2e8f0; padding-bottom: 8px; margin-bottom: 12px;">4. 모니터링과 피드백: "다음 무대를 위한 기록"</h4>
    <ul style="padding-left: 20px; line-height: 1.6;">
      <li style="margin-bottom: 8px;"><strong>직캠 촬영:</strong> 공식 영상 외에도 아티스트의 안무나 표정을 체크하기 위해 매니저가 직접 영상을 찍어 모니터링 자료를 만듭니다.</li>
      <li><strong>음향 체크:</strong> 무대 아래에서 소리가 너무 작거나 찢어지지는 않는지 듣고, 아티스트나 음향 스태프에게 즉시 피드백을 줍니다.</li>
    </ul>
  </div>

  <div style="margin-bottom: 25px;">
    <h4 style="color: #0369a1; border-bottom: 2px solid #e2e8f0; padding-bottom: 8px; margin-bottom: 12px;">5. 왜 가수 실무 기초 교육이 필요한가?</h4>
    <ul style="padding-left: 20px; line-height: 1.6;">
      <li style="margin-bottom: 8px;"><strong>빠른 판단력 요구:</strong> 음방이나 공연장은 순식간에 상황이 변합니다. 기초가 없으면 사고가 났을 때 대처하지 못하고 아티스트의 무대를 망칠 수 있습니다.</li>
      <li><strong>팀워크의 핵심:</strong> 댄서, 밴드, 코디네이터 등 함께 움직이는 인원이 많기 때문에 매니저가 중심에서 이들을 일사분란하게 조율해야 합니다.</li>
    </ul>
  </div>

  <div style="background-color: #f0f9ff; padding: 20px; border-radius: 12px; border-left: 5px solid #0284c7; margin-top: 30px;">
    <strong style="color: #0369a1; font-size: 1.1rem; display: block; margin-bottom: 10px;">💡 교육생을 위한 한 줄 요약</strong>
    <p style="margin: 0; color: #334155; font-style: italic; line-height: 1.6;">
      "가수 매니저는 아티스트가 무대 위에서 가장 빛나는 3분을 위해, 무대 뒤에서 24시간을 준비하는 지휘자입니다."
    </p>
  </div>
`;